import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const MissedCall = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.00002 7.5C6.60002 7.5 7.00002 7.1 7.00002 6.5V5.9L9.90002 8.8C11.1 10 13 10 14.1 8.8L18.7 4.2C19.1 3.8 19.1 3.2 18.7 2.8C18.3 2.4 17.7 2.4 17.3 2.8L12.7 7.4C12.3 7.8 11.7 7.8 11.3 7.4L8.40002 4.5H9.00002C9.60003 4.5 10 4.1 10 3.5C10 2.9 9.60003 2.5 9.00002 2.5H6.00002C5.40002 2.5 5.00002 2.9 5.00002 3.5V6.5C5.00002 7 5.40002 7.5 6.00002 7.5ZM21.9 14.9C16 10.4 7.90002 10.4 2.00002 14.9C1.40002 15.4 1.00002 16.1 0.900024 16.9C0.900024 17.7 1.10002 18.4 1.70002 19L3.50002 20.8C4.00002 21.3 4.70002 21.6 5.40002 21.6C6.00002 21.6 6.50002 21.4 6.90002 21.1C7.10002 21 7.20002 20.9 7.40002 20.8C7.70002 20.6 8.10002 20.4 8.40002 20.3C9.30002 19.9 9.70002 18.9 9.30002 18L9.20002 17.8C10.9 17.4 12.7 17.4 14.4 17.8L14.3 18C14 18.9 14.4 19.9 15.2 20.3C15.5 20.5 15.9 20.6 16.2 20.8C16.4 20.9 16.5 21 16.7 21.1C17.8 21.9 19.2 21.7 20.2 20.8L22 19C22.5 18.5 22.8 17.7 22.8 16.9C22.9 16.1 22.6 15.3 21.9 14.9Z"
      fill="currentColor"
    />
  </svg>
)

export default MissedCall
